export default __webpack_public_path__ + "static/media/heart-1-1.9bec3fc8.svg";